// RulesModal.jsx
// Sirf modal ka UI — rules data yahan nahi hai
// Usage: <RulesModal open={rulesOpen} onClose={() => setRulesOpen(false)} title={selectedGame} rulesText={GAME_RULES[selectedGame]} />

import React from 'react';
import { Box, Typography } from '@mui/material';

const RulesModal = ({ open, onClose, title = 'Game', rulesText = '' }) => {
    if (!open) return null;

    return (
        <Box
            onClick={onClose}
            sx={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.6)',
                zIndex: 1400,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
               
            }}
        >
            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                    width: '100%',
                      maxWidth: '100%',
                    maxHeight: '80vh',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    background: 'var(--Color-2, #fff)',
                    // border: '1.5px solid #7B5EA7',
                      marginTop: '49px',            // ← top touch
        alignSelf: 'flex-start', // ← upar se start ho
                }}
            >
                {/* ── Header ── */}
                <Box
                    sx={{
                        background: '#2C3D4D',
                        padding: '9px 10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexShrink: 0,
                        
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            fontFamily: 'font/family/poppins-var, Poppins, sans-serif',
                        }}
                    >
                        {title}&nbsp;
                        <span
                            style={{
                                background: '#F5C542',
                                color: '#1e2b3a',
                                fontSize: '14px',
                                fontWeight: 700,
                            }}
                        >
                            Rules
                        </span>
                    </Typography>

                    <button
                        onClick={onClose}
                        aria-label="Close"
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: '#fff',
                            fontSize: '16px',
                            cursor: 'pointer',
                            padding: '2px 6px',
                            lineHeight: 1,
                        }}
                    >
                        ✕
                    </button>
                </Box>

                {/* ── Body ──
                    Agar rulesText plain string hai  → Typography mein render
                    Agar rulesText JSX hai (Dragon Tiger) → directly render
                */}
                <Box sx={{ padding: '10px', overflowY: 'auto', flex: 1 }}>
                    {typeof rulesText === 'string' ? (
                        <Typography
                            sx={{
                                fontFamily: 'font/family/poppins-var, Poppins, sans-serif',
                                fontWeight: 600,
                                fontStyle: 'normal',
                                fontSize: 'var(--font-size-H1, 12px)',
                                lineHeight: 'var(--font-line-height-H1, 1.6)',
                                letterSpacing: '0%',
                                color: '#212121',
                                whiteSpace: 'pre-line',
                            }}
                        >
                            {rulesText}
                        </Typography>
                    ) : (
                        rulesText
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default RulesModal;